import { OCC_ENDPOINTS, OccFirstVisitLogParams } from '@analytics/const';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccAnalyticsService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  firstVisitLog(params: OccFirstVisitLogParams): Observable<unknown> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.firstVisitLog);

    return this.http.post(url, params, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.firstVisitLog),
      responseType: 'text',
    });
  }
}
